import BrandFooter from "./BrandFooter";

export default function LanguageGate({ languages = [], tenant, onSelect }) {
  const logoSrc =
    tenant?.markUrl ||
    tenant?.logoUrl ||
    tenant?.icons?.appleTouch ||
    tenant?.icons?.favicon;

  return (
    <div className="lang-gate">
      <div className="lang-gate__main">
        {logoSrc ? (
          <img
            className="lang-gate__logo"
            src={logoSrc}
            alt={tenant?.name ?? ""}
          />
        ) : (
          <div className="lang-gate__logo-fallback">
            {tenant?.name?.[0] ?? "🍽"}
          </div>
        )}
        {tenant?.name && <h1 className="lang-gate__brand">{tenant.name}</h1>}

        <ul className="lang-gate__list" aria-label="Language">
          {languages.map((item) => (
            <li key={item.code}>
              <button
                type="button"
                className="lang-gate__item"
                lang={item.code}
                dir="auto"
                onClick={() => onSelect(item.code)}
              >
                <span className="lang-gate__flag" aria-hidden="true">
                  {item.flag}
                </span>
                <span>{item.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>

      <footer className="lang-gate__footer">
        <BrandFooter />
      </footer>
    </div>
  );
}
